import { writable } from "svelte/store";

export const showRegisterInterestModal = writable(false);
